module.exports = __webpack_public_path__ + "img/go.977bb4f9.svg";